import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-message-modal',
    templateUrl: './message-modal.component.html',
    styleUrls: ['./message-modal.component.scss'],
    standalone: false
})
export class MessageModalComponent implements OnInit {

  public okayButtonText: string;
  public otherButtonText: string;
  public body: string;
  public title: string;
  public isOtherButtonVisible: boolean = true;
  
  constructor(public diaglogRef: MatDialogRef<MessageModalComponent>) { }

  ngOnInit() {
  }

  close(text) {
    this.diaglogRef.close(text);
  }
}
